(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  var backdrop = document.getElementById('CartBackdrop');
  if (!drawer || !backdrop) return;

  var TIMER_KEY = 'spyr_cart_reserved_until';
  var timerInterval = null;
  var inflight = 0;

  function timerMinutes() {
    return parseInt(drawer.getAttribute('data-timer-minutes'), 10) || 10;
  }

  function cartHasItems() {
    return !!drawer.querySelector('[data-cart-item]');
  }

  function ensureTimer() {
    if (!cartHasItems()) {
      sessionStorage.removeItem(TIMER_KEY);
      return;
    }
    var until = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10);
    if (!until) {
      until = Date.now() + timerMinutes() * 60 * 1000;
      sessionStorage.setItem(TIMER_KEY, String(until));
    }
  }

  function formatClock(seconds) {
    var m = Math.floor(seconds / 60);
    var s = seconds % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function renderTimer() {
    var wrap = drawer.querySelector('[data-cart-timer]');
    var clock = drawer.querySelector('[data-cart-timer-clock]');
    if (!wrap || !clock) return;
    var until = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10);
    if (!until || !cartHasItems()) {
      clock.textContent = formatClock(timerMinutes() * 60);
      wrap.classList.remove('is-expired');
      return;
    }
    var remaining = Math.max(0, Math.floor((until - Date.now()) / 1000));
    clock.textContent = formatClock(remaining);
    if (remaining === 0) {
      wrap.classList.add('is-expired');
    } else {
      wrap.classList.remove('is-expired');
    }
  }

  function startTimerInterval() {
    if (timerInterval) return;
    timerInterval = setInterval(renderTimer, 1000);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('is-open');
    document.body.classList.add('spyr-cart-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('is-open');
    document.body.classList.remove('spyr-cart-open');
  }

  function setLoading(on) {
    inflight += on ? 1 : -1;
    if (inflight < 0) inflight = 0;
    drawer.classList.toggle('is-loading', inflight > 0);
  }

  function applySectionResponse(data) {
    if (!data || !data.sections) return;
    var html = data.sections['cart-drawer'];
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#CartDrawer');
    if (fresh) drawer.innerHTML = fresh.innerHTML;
    ensureTimer();
    renderTimer();
  }

  // Single-roundtrip add: returns cart change result + rendered drawer HTML
  async function addToCart(variantId, quantity) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }],
        sections: 'cart-drawer'
      })
    });
    if (!res.ok) {
      var err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || 'Could not add to cart');
    }
    return res.json();
  }

  async function changeLine(line, quantity) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'cart-drawer'
      })
    });
    return res.json();
  }

  // Intercept add-to-cart forms (progressive enhancement — native submit is the fallback)
  document.addEventListener('submit', async function (e) {
    var form = e.target.closest && e.target.closest('.spyr-cta-form');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput) return;
    var id = idInput.value;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var btn = form.querySelector('button');

    // Open drawer immediately — animation masks the request latency
    openDrawer();
    if (btn) btn.setAttribute('disabled', 'disabled');
    setLoading(true);
    try {
      var data = await addToCart(id, qty);
      applySectionResponse(data);
    } catch (err) {
      console.error('[cart]', err);
      closeDrawer();
      // Fallback to native cart redirect
      form.removeEventListener('submit', arguments.callee);
      form.submit();
    } finally {
      if (btn) btn.removeAttribute('disabled');
      setLoading(false);
    }
  });

  // Per-line state for coalescing rapid clicks into a single in-flight request
  var lineState = {}; // { [line]: { target, sending, queued } }

  async function flushLine(line) {
    var state = lineState[line];
    if (!state) return;
    state.sending = true;
    state.queued = false;
    setLoading(true);
    try {
      var data = await changeLine(line, state.target);
      // Only re-render if no newer change has been queued for this line
      if (!state.queued) {
        applySectionResponse(data);
      }
    } catch (err) {
      console.error('[cart]', err);
    } finally {
      state.sending = false;
      setLoading(false);
      if (state.queued) {
        flushLine(line);
      } else {
        delete lineState[line];
      }
    }
  }

  function queueLineChange(line, newQty) {
    if (!lineState[line]) lineState[line] = { target: newQty, sending: false, queued: false };
    lineState[line].target = newQty;
    if (lineState[line].sending) {
      lineState[line].queued = true;
      return;
    }
    flushLine(line);
  }

  // Delegated clicks: close, qty, remove
  document.addEventListener('click', function (e) {
    if (e.target === backdrop || (e.target.closest && e.target.closest('[data-cart-close]'))) {
      closeDrawer();
      return;
    }

    var item = e.target.closest && e.target.closest('[data-cart-item]');
    if (!item) return;
    var line = parseInt(item.getAttribute('data-line'), 10);
    var qtyEl = item.querySelector('[data-cart-qty]');
    var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
    var newQty = null;

    if (e.target.closest('[data-cart-remove]')) {
      newQty = 0;
    } else if (e.target.closest('[data-cart-increase]')) {
      newQty = currentQty + 1;
    } else if (e.target.closest('[data-cart-decrease]')) {
      newQty = Math.max(0, currentQty - 1);
    } else {
      return;
    }

    e.preventDefault();

    // Optimistic UI: update qty number immediately so the user feels the click
    if (qtyEl && newQty > 0) qtyEl.textContent = newQty;
    if (newQty === 0) item.style.opacity = '0.5';

    queueLineChange(line, newQty);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  ensureTimer();
  renderTimer();
  startTimerInterval();
})();
